"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.PhoneNumberBodyToJSON = exports.PhoneNumberBodyFromJSONTyped = exports.PhoneNumberBodyFromJSON = void 0;
function PhoneNumberBodyFromJSON(json) {
    return PhoneNumberBodyFromJSONTyped(json, false);
}
exports.PhoneNumberBodyFromJSON = PhoneNumberBodyFromJSON;
function PhoneNumberBodyFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'countryCode': json['countryCode'],
        'nationalNumber': json['nationalNumber'],
    };
}
exports.PhoneNumberBodyFromJSONTyped = PhoneNumberBodyFromJSONTyped;
function PhoneNumberBodyToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'countryCode': value.countryCode,
        'nationalNumber': value.nationalNumber,
    };
}
exports.PhoneNumberBodyToJSON = PhoneNumberBodyToJSON;
